import {
  PECPLUS_STATUS_IN_PROGRESS_DESCR,
  PECPLUS_STATUS_ERROR_DESCR,
  STORE_KEY_ID_LIST
} from 'Constants'

import { storeGet } from 'Helpers/localStorage'
import { atom, selector, selectorFamily } from 'recoil'

export const pageState = atom({
  key: 'campaignsSendStatusPageState',
  default: {
    fetchingResults: false,
    error: undefined
  }
})

export const pageErrorState = atom({
  key: 'campaignsSendStatusPageErrorState',
  default: {
    error: undefined,
    severity: 'danger'
  }
})

export const resultsLoadingState = atom({
  key: 'campaignsSendStatusResultsLoadingState',
  default: {
    fetchingResults: false
  }
})

export const listSendingInitialState = {
  fetchingResults: false,
  error: undefined,
  Items: [],
  HasHidden: 0,
  HasImmediateHidden: 0,
  ToSend: 0,
  TotBytes: 0,
  TotalSendTime: 0
}

export const listSendingState = atom({
  key: 'campaignsSendStatusListSendingState',
  default: listSendingInitialState
})

export const listScheduledIntialState = {
  fetchingResults: false,
  error: undefined,
  Items: []
}

export const listScheduledState = atom({
  key: 'campaignsSendStatusListScheduledState',
  default: listScheduledIntialState
})

export const listWaitingInitialState = {
  fetchingResults: false,
  error: undefined,
  Items: []
}

export const listWaitingState = atom({
  key: 'campaignsSendStatusListWaitingState',
  default: listWaitingInitialState
})

export const pecPlusConfigState = atom({
  key: 'campaignsSendStatusPecPlusConfigState',
  default: []
})

export const itemLoadingState = atom({
  key: 'campaignsSendStatusItemLoadingState',
  default: []
})

/*****************************************************************************/

export const loadingState = selector({
  key: 'campaignsSendStatusLoadingState',
  get: ({ get }) => {
    const { fetchingResults } = get(pageState)
    const { fetchingResults: fetchingAllResults } = get(resultsLoadingState)
    //  const { fetchingResults: fetchingSendingResults } = get(listSendingState)
    //  const { fetchingResults: fetchingScheduledResults } = get(listScheduledState)
    //  const { fetchingResults: fetchingWaitingResults } = get(listWaitingState)

    return [
      fetchingResults,
      fetchingAllResults
      //  fetchingSendingResults,
      //  fetchingScheduledResults,
      //  fetchingWaitingResults
    ].some(value => value)
  }
})

export const pecPlusStatusState = selector({
  key: 'campaignsSendStatusPecPlusStatusState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    const idList = storeGet(STORE_KEY_ID_LIST)

    const config = configs.find(c => c.IdList === idList)
    return config?.Status
    //  $scope.setScheduleConfig
  }
})

export const pecPlusListStatusState = selectorFamily({
  key: 'campaignsSendStatusPecPlusListStatusState',
  get: idList => ({ get }) => {
    const configs = get(pecPlusConfigState)

    const config = configs.find(c => c.IdList === idList)
    return config?.Status
  }
})

export const pecPlusErrorState = selector({
  key: 'campaignsSendStatusPecPlusErrorState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    return configs.filter(c => c.Status === PECPLUS_STATUS_ERROR_DESCR)
    //  return configs
  }
})

export const pecPlusInProgressState = selector({
  key: 'campaignsSendStatusPecPlusInProgressState',
  get: ({ get }) => {
    const configs = get(pecPlusConfigState)
    return configs.filter(c => c.Status === PECPLUS_STATUS_IN_PROGRESS_DESCR)
  }
})

export const itemLoadingSelector = selectorFamily({
  key: 'campaignsSendStatusItemLoadingSelector',
  get: idSending => ({ get }) => {
    return get(itemLoadingState).includes(idSending)
  },
  set: idSending => ({ set }, loading) => {
    if (loading) {
      set(itemLoadingState, prev => prev.concat(idSending))
    } else {
      set(itemLoadingState, prev => prev.filter(o => o !== idSending))
    }
  }
})

export const itemScheduleDetailsSelector = selectorFamily({
  key: 'campaignsSendStatusItemScheduleDetails',
  get: idSending => ({ get }) => {
    const { date, timeZoneCode } = []
      .concat(get(listScheduledState).Items, get(listWaitingState).Items)
      .find(
        item => item.idSending === idSending
      )
    return {
      idSending,
      date,
      timeZoneCode
    }
  }
})
